import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
	Button,
	Dialog,
	DialogActions,
	DialogTitle,
	IconButton,
	ListItemIcon,
	Menu,
	MenuItem,
} from "@mui/material";
import React, { useState } from "react";

type MenuAction = {
	callback: () => void;
	text: string | React.ReactElement;
	icon: React.ReactElement;
	showDialog: boolean;
	dialogTitle?: string;
};

const MenuActions = ({
	menuActions,
	id,
}: {
	menuActions: MenuAction[];
	id?: string;
}) => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const [openDialog, setOpenDialog] = useState<MenuAction>(null);
	const openBool = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleCloseDialog = () => {
		setOpenDialog(null);
	};
	const handleOpenDialog = (action: MenuAction) => {
		handleClose();
		setOpenDialog(action);
	};

	const handleCallback = (action: MenuAction) => {
		if (action.showDialog) {
			handleOpenDialog(action);
		} else {
			action.callback();
		}
		handleClose();
	};

	const handleDialogCallback = (callback: () => void) => {
		callback();
		handleCloseDialog();
	};

	return (
		<>
			{openDialog !== null ? (
				<Dialog onClose={handleCloseDialog} open={openDialog !== null}>
					<DialogTitle>{openDialog.dialogTitle}</DialogTitle>
					<DialogActions>
						<Button onClick={handleCloseDialog}>Cancel</Button>
						<Button
							variant="contained"
							onClick={() => handleDialogCallback(openDialog.callback)}
							autoFocus
						>
							Yes
						</Button>
					</DialogActions>
				</Dialog>
			) : null}
			<Menu
				id={`${id}-menu`}
				anchorEl={anchorEl}
				open={openBool}
				onClose={handleClose}
				slotProps={{
					list: {
						"aria-labelledby": "basic-button",
					},
				}}
			>
				{menuActions.map((action, idx) => {
					return (
						<MenuItem key={idx} onClick={() => handleCallback(action)}>
							<ListItemIcon>{action.icon}</ListItemIcon>
							{action.text}
						</MenuItem>
					);
				})}
			</Menu>
			<IconButton aria-label="settings" onClick={handleClick}>
				<MoreVertIcon />
			</IconButton>
		</>
	);
};

export default MenuActions;
